import logger from '../../logger';

const injectStyle = style => {
  const styleElement = document.createElement('style');

  document.head.appendChild(styleElement);

  try {
    styleElement.sheet.insertRule(style, styleElement.sheet.cssRules.length);
  } catch (err) {
    logger.info(err);
  }
};

module.exports = injectStyle;



// WEBPACK FOOTER //
// ./src/common/utils/injectStyles.js